import selectArrowWhite from 'media/select-arrow-white.svg'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {
  translatedLanguageNames,
  languages as allLanguages,
} from '../../locale'
import useLocale from '../../hooks/useLocale'
import useClickOutside from '../../hooks/useClickOutside'
import Checkmark from 'media/checkmark.svg?svgr-webpack'

const PartnerLanguageSwitcher = ({
  languages = allLanguages,
  onLanguageChange,
}) => {
  const [showMenu, setShowMenu] = useState(false)
  const { language: currentLanguage, setLanguage } = useLocale()

  const { ref } = useClickOutside(() => {
    if (showMenu) setShowMenu(false)
  })

  const handleLanguageClick = (lang) => () => {
    setLanguage(lang, false)
    setShowMenu(false)
    onLanguageChange && onLanguageChange(lang)
  }

  const handleKeyUp = (e) => {
    if (e.keyCode === 27) {
      setShowMenu(false)
    }
  }

  if (languages.length === 0) {
    return null
  }

  return (
    <div ref={ref} className="relative" onKeyUp={handleKeyUp}>
      <button
        className="text-white type-17-demibold-caps"
        type="button"
        onClick={() => setShowMenu(!showMenu)}
        aria-controls="language-dropdown"
        aria-expanded={showMenu.toString()}
        data-uid="partner-language-switcher-button"
        data-testid="partner-language-switcher-button"
      >
        <div className="flex items-center">
          {currentLanguage}
          <div className="ml-4">
            <img
              src={selectArrowWhite}
              alt=""
              style={{ width: 9, height: 'auto' }}
              className="-mt-1"
            />
          </div>
        </div>
      </button>
      <ul
        className={classNames('absolute top-0 mt-32 rounded-8 bg-black py-8', {
          hidden: !showMenu,
        })}
        id="language-dropdown"
      >
        {languages.map((lang) => (
          <li key={lang}>
            <button
              className={classNames(
                'block cursor-pointer py-4 text-white type-20',
                {
                  'font-demibold': lang === currentLanguage,
                },
              )}
              onClick={handleLanguageClick(lang)}
              data-uid="partner-language-switcher-language"
            >
              <div className="flex flex-row pl-12 pr-24">
                <div className="mr-12 w-16">
                  {lang === currentLanguage && (
                    <Checkmark className="h-16 w-16 stroke-current" />
                  )}
                </div>
                <div>{translatedLanguageNames[lang]}</div>
              </div>
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}

PartnerLanguageSwitcher.propTypes = {
  languages: PropTypes.arrayOf(PropTypes.string),
  onLanguageChange: PropTypes.func,
}

export default PartnerLanguageSwitcher
